import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const firstString = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return String(arr[0] || '').trim();
};

/**
 * Transforms instagram criteria.
 * Minimal output: Name + URL.
 *
 * @param {Object} instagramCriteria - criteria.instagram
 * @returns {Object} transformed criteria
 */
export const transformInstagramAccount = (instagramCriteria) => {
  if (!instagramCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Instagram Account was found.',
      data: null,
    };
  }

  const wooRankStatus = instagramCriteria?.status || 'neutral';
  const importance = instagramCriteria?.importance || 0;
  const solvability = instagramCriteria?.solvability || 0;

  const name = String(instagramCriteria?.data?.name || '').trim();
  const url = firstString(instagramCriteria?.data?.urls);

  const isEmpty = !name && !url;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Instagram Account was found.' : null,
    data: isEmpty ? null : { name, url },
  };
};

export default transformInstagramAccount;


